import { AGENT_CHAT_SET_DATA } from "src/redux/actions/agentChat";
import { LinkI } from "src/types/Link";

export type AgentChatAction = {
  type: typeof AGENT_CHAT_SET_DATA;
  payload: LinkI;
};

const agentChat = (state: LinkI = null, action: AgentChatAction): LinkI => {
  switch (action.type) {
    case AGENT_CHAT_SET_DATA:
      return action.payload;
    default:
      return state;
  }
};

export default agentChat;
